import { Box, Typography } from "@mui/material";
import { EmailFormProps, EmailForm, EmailFormSchema } from "../../../Forms";
import { useMutation } from "@apollo/client";
import { EditStudentParentEmailMutation, EditStudentParentEmailMutationVariables, EDIT_STUDENT_PARENT_EMAIL, Student, StudentDataType } from "ft-shared-graphql";

export type EmailFormWrapperProps = {
    studentData: StudentDataType,
    updateStudent: (student: StudentDataType | undefined) => void,

}
function EmailFormWrapper({ studentData, updateStudent }: EmailFormWrapperProps) {
    const [editStudentParentEmail, { data }] =
        useMutation<EditStudentParentEmailMutation, EditStudentParentEmailMutationVariables>(EDIT_STUDENT_PARENT_EMAIL);

    const handleSubmit = async (values: EmailFormSchema) => {
        const response = await editStudentParentEmail({
            variables: {
                id: studentData!.id,
                parentEmail: values.email
            }
        });

        // Update the student (player) context object with the new parent email value
        // but do not overwrite exsiting values
        updateStudent({
            parentEmail: values.email
        } as Student);

    }
    return (
        <Box>
            <Typography>There's no parent email for this child, please provide an email.</Typography>
            <EmailForm onSubmit={handleSubmit} />
        </Box>
    )
}
export default EmailFormWrapper